var _path, _defs, _clipPath, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 123 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3150a2",
    d: "M8.4 0L4.8 6.3 1.2 0H0v8h1.3V2.7l3 5.3h1l3-5.3V8h1.3V0zM20 1.7l1.7 3.6h-3.3L20 1.7zM19.4 0l-3.7 8h1.4l.6-1.3h4.6l.6 1.3h1.4l-3.7-8h-1.2zm11.4 0h1.3v8h-1.3z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "text_svg__a",
    d: "M0 0h123v8H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "text_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#text_svg__a"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3150a2",
    d: "M41.7 1.3c.7 0 1.2.4 1.4 1.3l1.2-.5C44 .8 43 0 41.8 0c-1.3 0-2.4.8-2.4 2.3C39.4 5 43 4.2 43 5.8c0 .6-.4.9-1.1.9-.8 0-1.3-.5-1.5-1.4l-1.1.6c.2 1.6 1.4 2.1 2.5 2.1 1.3 0 2.4-.7 2.4-2.3 0-2.8-3.6-1.9-3.6-3.5 0-.5.4-.9 1.1-.9m13.2 5.4c-1.5 0-2.7-1.1-2.7-2.7s1.1-2.7 2.7-2.7c1.5 0 2.7 1.1 2.7 2.7s-1.1 2.7-2.7 2.7m0-6.7c-2.3 0-4 1.7-4 4s1.7 4 4 4 4-1.7 4-4-1.7-4-4-4",
    clipPath: "url(#text_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3150a2",
    d: "M71.7 0v5.8L67 0h-1.2v8h1.3V2.3L71.8 8H73V0zm8.5 0v8h5V6.7h-3.7v-2h3.7V3.3h-3.7v-2h3.7V0zm11.2 0v1.3h3V8h1.3V1.3h3V0zm12.9 0v1.3h3V8h1.3V1.3h3V0zM118 0v8h5V6.7h-3.7v-2h3.7V3.3h-3.7v-2h3.7V0z"
  })));
};

export default SvgText;